// Brunch automatically concatenates all files in your
// watched paths. Those paths can be configured at
// config.paths.watched in "brunch-config.js".
//
// However, those files will only be executed if
// explicitly imported. The only exception are files
// in vendor, which are never wrapped in imports and
// therefore are always executed.

// Import dependencies
//
// If you no longer want to use a dependency, remember
// to also remove its path from "config.paths.watched".

// Import local files
//
// Local files can be imported directly using relative
// paths "./socket" or full ones "web/static/js/socket".

// import socket from "./socket"

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueHighlightJS from 'vue-highlightjs';
import VueApollo from 'vue-apollo';
import VueClipboards from 'vue-clipboards';
import VueHead from 'vue-head';
import VueTimeago from 'vue-timeago';
import timeagoLocale from 'vue-timeago/locales/de-DE.json';

// Global Lodash plugins
import 'lodash.product';

// Load UIkit and other layout stuff
import './theme';

// Load Apollo Client
import apolloClient from './api/client';

// Load store
import store from './store';

// Load router
import router from './router';

// Load app view
import App from './views/App';

// Load global filters
import './filters';

// Load global components and filters
import AlertBox from './components/AlertBox';
import Icon from './components/Icon';
import LinkButton from './components/LinkButton';
import i18n, {
  LOCALE,
} from './i18n';
import { init } from './common/auth';

Vue.component('alert-box', AlertBox);
Vue.component('icon', Icon);
Vue.component('link-button', LinkButton);

// Setup an Apollo provider for GraphQL queries
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

// Register several plugins globally
Vue.use(VueHighlightJS);
Vue.use(VueApollo);
Vue.use(VueClipboards);
Vue.use(VueHead);
Vue.use(VueTimeago, {
  name: 'timeago', // component name, `timeago` by default
  locale: LOCALE,
  locales: {
    [LOCALE]: timeagoLocale,
  },
});

init();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  apolloProvider,
  i18n,
  template: '<app />',
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./app.js